import React from 'react'
import { Provider as ReduxStoreProvider } from 'react-redux'
import { BrowserRouter, Routes, Route } from 'react-router'

import AppContextWrapper from './context/AppContextWrapper'
import Checkpoint from './features/Checkpoint'
import Auth from './features/Auth'
import Main from './features/Main'
import { SubMainScroll, SubMainNoScroll } from './features/SubMain'
import Home from './features/Home'
import User from './features/User'
import Post from './features/Post'
import EmailVerification from './features/EmailVerification'
import Settings from './features/Settings'
import SettingsWindow from './components/settings/SettingsWindow'
import Profile from './components/settings/Profile'
import FollowList from './features/Follows'
import TokenCheckpoint from './features/TokenCheckpoint'
import PostMedia from './features/Media/PostMedia'
import NotFoundMedia from './components/fallback/NotFoundMedia'
import Explore from './features/Explore'
import Notifications from './features/Notifications'
import Messages from './features/Messages'
import Bookmarks from './features/Bookmarks'
import Communities from './features/Communities'
import Games from './features/Games'
import Surprise from './features/Surprise'
import UserMediaSpecific from './features/Media/UserMedia'
import { store } from './store'

const App: React.FC = () => {
  // maybe someday we can make this more dynamic and persistent per user-preference
  document.documentElement.setAttribute('data-theme', 'dark')

  return (
    <AppContextWrapper>
      <ReduxStoreProvider store={store}>
        <BrowserRouter>
          <Routes>
            <Route element={<Checkpoint />}>
              <Route path="/" element={<Auth />} />
              <Route element={<Main />}>
                <Route element={<SubMainScroll />}>
                  <Route path="home">
                    <Route index element={<Home />} />
                  </Route>
                  <Route path=":username">
                    <Route index element={<User />} />
                    <Route path=":postId" element={<Post />} />
                    <Route
                      path="following"
                      element={<FollowList type={'following'} />}
                    />
                    <Route
                      path="followers"
                      element={<FollowList type={'followers'} />}
                    />
                  </Route>
                  <Route path="settings/profile">
                    <Route index element={<Profile />} />
                  </Route>
                </Route>
                <Route path="settings" element={<Settings />}>
                  <Route path="account" element={<SettingsWindow />} />
                  <Route path="monetization" element={<SettingsWindow />} />
                  <Route path="premium" element={<SettingsWindow />} />
                  <Route path="subscriptions" element={<SettingsWindow />} />
                  <Route path="accessibility" element={<SettingsWindow />} />
                  <Route path="security" element={<SettingsWindow />} />
                  <Route path="privacy" element={<SettingsWindow />} />
                  <Route path="notifications" element={<SettingsWindow />} />
                  <Route path="resources" element={<SettingsWindow />} />
                  <Route path="help" element={<SettingsWindow />} />
                  <Route path="information" element={<SettingsWindow />} />
                  <Route path="password" element={<SettingsWindow />} />
                  <Route path="deactivate" element={<SettingsWindow />} />
                  <Route path="display" element={<SettingsWindow />} />
                  {/* seriously though... I feel like I need to invoke every single available route for settings, just to be safe.. instead of having them all go through '*' and be filtered inside the component */}
                  <Route path="*" element={<SettingsWindow />} />
                </Route>
                <Route element={<SubMainNoScroll />}>
                  <Route path="explore">
                    <Route index element={<Explore />} />
                  </Route>
                  <Route path="notifications">
                    <Route index element={<Notifications />} />
                  </Route>
                  <Route path="messages">
                    <Route index element={<Messages />} />
                  </Route>
                  <Route path="bookmarks">
                    <Route index element={<Bookmarks />} />
                  </Route>
                  <Route path="communities">
                    <Route index element={<Communities />} />
                  </Route>
                  <Route path="games">
                    <Route index element={<Games />} />
                  </Route>
                  <Route path="surprise">
                    <Route index element={<Surprise />} />
                  </Route>
                </Route>
              </Route>
              <Route element={<TokenCheckpoint />}>
                <Route path="media/post" element={<PostMedia />} />
                <Route
                  path="media/profilePicture"
                  element={<UserMediaSpecific />}
                />
                <Route
                  path="media/headerPicture"
                  element={<UserMediaSpecific />}
                />
                <Route path="media/*" element={<NotFoundMedia />} />
              </Route>
            </Route>

            {/* EMAIL VERIFICATION */}
            <Route path="/emailVerification" element={<EmailVerification />} />
          </Routes>
        </BrowserRouter>
      </ReduxStoreProvider>
    </AppContextWrapper>
  )
}

export default App
